import { render, staticRenderFns } from "./ViewPostActionViewerMenu.vue?vue&type=template&id=ee379e7e&"
import script from "./ViewPostActionViewerMenu.vue?vue&type=script&lang=js&"
export * from "./ViewPostActionViewerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports